import React from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { PlatformContext } from "../components/Platform/PlatformContext";
import ReactMarkdown from "react-markdown";

const privacyMarkdown = `
# Datenschutzerklärung - Faculties Football League App

**Stand:** April 2026  
**Gültig für:** iOS App (Apple App Store) und Android App (Google Play Store)

---

## 1. Verantwortlicher

Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist:

**Faculties Football League e.V.**  
Arcisstraße 17  
c/o Studentische Vertretung  
80333 München  
Deutschland

**E-Mail:** board@facultiesfootballleague.de  
**Website:** facultiesfootballleague.de

---

## 2. Datenschutzbeauftragte/r

**Levi Frim**  
Vorstandsvorsitzender / Datenschutzbeauftragter  
E-Mail: levi.frim@facultiesfootballleague.de

Bei Fragen und Anliegen zum Datenschutz wenden Sie sich bitte direkt an unsere/n Datenschutzbeauftragte/n.

---

## 3. Allgemeines zur Datenverarbeitung

### 3.1 Umfang der Verarbeitung personenbezogener Daten

Wir erheben und verwenden personenbezogene Daten unserer Nutzer/innen grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen App sowie unserer Inhalte und Leistungen erforderlich ist. Die Erhebung und Verwendung personenbezogener Daten unserer Nutzer/innen erfolgt regelmäßig nur nach Einwilligung der Nutzer/in. Eine Ausnahme gilt in solchen Fällen, in denen eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.

### 3.2 Rechtsgrundlagen für die Verarbeitung personenbezogener Daten

Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage.

Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind.

Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.

Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.

### 3.3 Datenlöschung und Speicherdauer

Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung der Daten für einen Vertragsabschluss oder eine Vertragserfüllung besteht.

---

## 4. Bereitstellung der App und Erstellung von Protokolldateien

### 4.1 Beschreibung und Umfang der Datenverarbeitung

Bei der Nutzung unserer App werden automatisch Informationen erhoben, die Ihr Endgerät an unsere Server übermittelt. Diese Informationen werden temporär in sogenannten Session-Protokolldaten gespeichert. Folgende Daten werden dabei erhoben:

- IP-Adresse des anfragenden Geräts
- Datum und Uhrzeit der Anfrage (Zeitstempel)
- Art und Version des verwendeten Browsers bzw. der verwendeten App
- Betriebssystem und Version des Endgeräts
- Referrer-URL (soweit übermittelt)
- Sitzungs-ID (Session-Token)

Die Verarbeitung dieser technischen Daten ist notwendig, um die App-Verbindung zum Server herzustellen, die Sicherheit des Systems zu gewährleisten und technische Fehler zu erkennen und zu beheben.

### 4.2 Rechtsgrundlage

Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der Gewährleistung des ordnungsgemäßen Betriebs, der Sicherheit der Systeme sowie der Mißbrauchserkennung und -prävention.

### 4.3 Dauer der Speicherung# Datenschutzerklärung – Faculties Football League App

**Stand:** April 2026  
**Gültig für:** iOS App (Apple App Store) und Android App (Google Play Store)

---

## 1. Verantwortlicher

Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist:

**Faculties Football League e.V.**  
Arcisstraße 17  
c/o Studentische Vertretung  
80333 München  
Deutschland

**E-Mail:** board@facultiesfootballleague.de  
**Website:** facultiesfootballleague.de

---

## 2. Datenschutzbeauftragte/r

**Levi Frim**  
Vorstandsvorsitzender / Datenschutzbeauftragter  
E-Mail: levi.frim@facultiesfootballleague.de

Bei Fragen und Anliegen zum Datenschutz wenden Sie sich bitte direkt an unsere/n Datenschutzbeauftragte/n.

---

## 3. Allgemeines zur Datenverarbeitung

### 3.1 Umfang der Verarbeitung personenbezogener Daten

Wir erheben und verwenden personenbezogene Daten unserer Nutzer/innen grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen App sowie unserer Inhalte und Leistungen erforderlich ist. Die Erhebung und Verwendung personenbezogener Daten unserer Nutzer/innen erfolgt regelmäßig nur nach Einwilligung der Nutzer/in. Eine Ausnahme gilt in solchen Fällen, in denen eine vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.

### 3.2 Rechtsgrundlagen für die Verarbeitung personenbezogener Daten

Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage.

Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind.

Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.

Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.

### 3.3 Datenlöschung und Speicherdauer

Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung der Daten für einen Vertragsabschluss oder eine Vertragserfüllung besteht.

---

## 4. Bereitstellung der App und Erstellung von Protokolldateien

### 4.1 Beschreibung und Umfang der Datenverarbeitung

Bei der Nutzung unserer App werden automatisch Informationen erhoben, die Ihr Endgerät an unsere Server übermittelt. Diese Informationen werden temporär in sogenannten Session-Protokolldaten gespeichert. Folgende Daten werden dabei erhoben:

- IP-Adresse des anfragenden Geräts
- Datum und Uhrzeit der Anfrage (Zeitstempel)
- Art und Version des verwendeten Browsers bzw. der verwendeten App
- Betriebssystem und Version des Endgeräts
- Referrer-URL (soweit übermittelt)
- Sitzungs-ID (Session-Token)

Die Verarbeitung dieser technischen Daten ist notwendig, um die App-Verbindung zum Server herzustellen, die Sicherheit des Systems zu gewährleisten und technische Fehler zu erkennen und zu beheben.

### 4.2 Rechtsgrundlage

Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der Gewährleistung des ordnungsgemäßen Betriebs, der Sicherheit der Systeme sowie der Mißbrauchserkennung und -prävention.

### 4.3 Dauer der Speicherung

Die Session-Protokolldaten werden spätestens nach 30 Tagen gelöscht oder anonymisiert, sobald sie für die Zwecke, für die sie erhoben wurden, nicht mehr erforderlich sind.

---

## 5. Registrierung und Authentifizierung

### 5.1 Beschreibung und Umfang der Datenverarbeitung

Die Nutzung unserer App setzt eine Registrierung voraus. Die Authentifizierung erfolgt ausschließlich über Google OAuth, wobei die Weiterleitung der Anmeldedaten über den DFN-AAI-Proxy des Deutschen Forschungsnetzes (DFN-Verein) erfolgen kann. Dabei werden folgende personenbezogene Daten verarbeitet:

**Durch Google OAuth übermittelte Daten:**
- Vollständiger Name
- E-Mail-Adresse
- Google-Konto-Kennung (Account-ID)

**Durch DFN-AAI übermittelte Daten (bei Nutzung des Bildungsbereichs):**
- Name
- E-Mail-Adresse
- Sonstige Identifikatoren (z. B. universitäre Kennung)
- Ggf. Gruppenzugehörigkeiten und Rollen innerhalb der jeweiligen Heimateinrichtung
- Ggf. Meldeadresse

**In unserer Datenbank gespeicherte Daten:**
- Eindeutige Benutzer-ID (UUID)
- Vollständiger Name
- E-Mail-Adresse (verifiziert)
- Profilbild (URL zum Speicherort)
- Stripe-Kunden-ID (bei Zahlungen)
- Erstellungsdatum und Datum der letzten Aktualisierung
- OAuth-Provider-ID und -Typ
- OAuth-Zugriffs- und Aktualisierungstoken (verschlüsselt)

**Session-Daten:**
- Sitzungstoken
- IP-Adresse
- User-Agent (Geräteinformationen, Browser-/App-Version)
- Ablaufzeit der Sitzung

### 5.2 Rechtsgrundlage

Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO. Dient die Registrierung der Vorbereitung oder Erfüllung eines Vertrages, so ist Art. 6 Abs. 1 lit. b DSGVO zusätzliche Rechtsgrundlage. Die Speicherung von IP-Adresse und User-Agent im Rahmen der Sitzungsverwaltung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (Sicherheit und Missbrauchsprävention).

### 5.3 Dauer der Speicherung

Die Registrierungs- und Profildaten werden gespeichert, solange der Account besteht. Sitzungsdaten werden nach Ablauf der Sitzung oder nach dem Abmelden automatisch gelöscht. Sitzungstoken laufen nach einer definierten Inaktivitätsphase automatisch ab.

### 5.4 Widerspruchs- und Beseitigungsmöglichkeit

Als Nutzer/in haben Sie jederzeit die Möglichkeit, Ihre Registrierung aufzuheben. Die über Sie gespeicherten Daten können Sie jederzeit abändern lassen (Kontakt: levi.frim@facultiesfootballleague.de). Bei Löschung des Accounts werden alle personenbezogenen Daten einschließlich verknüpfter Team-Mitgliedschaften, Sitzungsdaten und OAuth-Verbindungen durch automatische Kaskadierung gelöscht.

---

## 6. Profilbild und Medien-Uploads

### 6.1 Beschreibung und Umfang der Datenverarbeitung

Die App ermöglicht das Hochladen eines Profilbilds (Nutzerfoto) sowie eines Team-Logos. Hierzu werden folgende Daten verarbeitet:

- Das von Ihnen ausgewählte Bild aus Ihrer Gerätegalerie
- Vorübergehende Speicherung im Gerätedateisystem während des Upload-Vorgangs
- Permanente Speicherung in unserem S3-kompatiblen Objektspeicher (Hetzner) unter einem eindeutigen Pfad (\`user-images/{BenutzerID}\` bzw. \`team-images/{TeamID}\`)
- Öffentlich zugängliche URL des hochgeladenen Bildes

Profilbilder sind für andere eingeloggte Nutzer/innen der App sichtbar. Team-Logos sind öffentlich auf der Website und in der App sichtbar.

Die App fordert für die Bildauswahl folgende Geräteberechtigung an:
- **Zugriff auf die Fotomediathek** (Lesen): Notwendig zur Auswahl eines Profilbilds oder Team-Logos

Hinweis: Die optionale Funktion zur Hintergrundentfernung bei Team-Logos wird vollständig lokal auf Ihrem Gerät verarbeitet. Dabei werden keine Bilddaten an externe Dienste übermittelt.

### 6.2 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Erfüllung des Vertragsverhältnisses für die Nutzung der App).

### 6.3 Dauer der Speicherung

Bilder werden im Objektspeicher gespeichert, solange der entsprechende Account oder das Team besteht. Nach Löschung des Accounts oder Teams werden die Bilder unverzüglich aus dem Objektspeicher entfernt.

---

## 7. Zahlungsabwicklung (Season Pass)

### 7.1 Beschreibung und Umfang der Datenverarbeitung

Zur Teilnahme an der Saison ist der Erwerb eines „Season Pass" erforderlich. Die Zahlungsabwicklung erfolgt über den Zahlungsdienstleister Stripe. Bei der Abwicklung von Zahlungen werden folgende Daten verarbeitet:

- Stripe-Kunden-ID (in unserer Datenbank gespeichert, verknüpft mit Ihrem Account)
- Zahlungsintent-Client-Secret (temporär für die Zahlung)
- Zahlungsbetrag und Währung (EUR)
- Zahlungsstatus und Zeitstempel

**Wichtig:** Kreditkartendaten und sonstige vollständige Zahlungsinformationen werden **nicht** auf unseren Servern gespeichert. Diese werden ausschließlich von Stripe verschlüsselt verarbeitet und gespeichert. Stripe ist als Zahlungsdienstleister nach PCI DSS zertifiziert.

Beim Anlegen Ihres Accounts wird automatisch ein Stripe-Kundenprofil erstellt, dem eine eindeutige Kunden-ID zugewiesen wird.

### 7.2 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. c DSGVO (Erfüllung steuerrechtlicher und handelsrechtlicher Aufzeichnungspflichten nach § 147 AO, § 257 HGB).

### 7.3 Auftragsverarbeiter

Zahlungsabwicklung: **Stripe Payments Europe, Limited**, 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, D02 H210, Irland. Eine Auftragsverarbeitungsvereinbarung gemäß Art. 28 DSGVO besteht mit Stripe. Die Datenschutzerklärung von Stripe ist unter stripe.com/de/privacy abrufbar.

### 7.4 Dauer der Speicherung

Zahlungsdaten (insbesondere die Stripe-Kunden-ID in unserem System) werden für die Dauer des Vertragsverhältnisses und anschließend für die gesetzlich vorgeschriebenen Aufbewahrungsfristen (mindestens 10 Jahre gemäß § 147 AO, § 257 HGB) gespeichert.

---

## 8. Team-Funktionen und Liga-Verwaltung

### 8.1 Beschreibung und Umfang der Datenverarbeitung

Die Kernfunktion unserer App ist die Verwaltung von Fußballteams und die Organisation von Ligaspielen. Hierzu verarbeiten wir folgende Daten:

**Team-Daten:**
- Teamname
- Team-Kürzel (3-Buchstaben-Kennung)
- Team-Logo
- Teamgründungsdatum
- Mitgliederrollen: Kapitän (CAPTAIN), Ko-Kapitän (CO_CAPTAIN), Mitglied (MEMBER), Bewerber/in (APPLICANT)

**Mitgliedschaftsdaten:**
- Zuordnung von Nutzer/innen zu Teams
- Rollen und Berechtigungen innerhalb des Teams
- Bewerbungsstatus

**Ligadaten:**
- Saison-Informationen
- Spielpaarungen (geplante Funktion)
- Statistiken: Siege, Niederlagen, Unentschieden, Rangliste (geplante Funktion)
- Ergebnisse

### 8.2 Öffentlich sichtbare Daten

Folgende Daten werden **öffentlich** auf unserer Website (facultiesfootballleague.de) und in der App angezeigt:

- Teamname
- Team-Kürzel
- Team-Logo
- Name des/der Teamkapitän/s
- Anzahl der Teammitglieder
- Ligatabelle und Statistiken (Siege, Niederlagen, Unentschieden, Punkte)
- Spielergebnisse

Mit der Annahme der Nutzungsbedingungen und der Registrierung in der App stimmen Sie zu, dass Ihr Name als Kapitän/Ko-Kapitän öffentlich sichtbar sein kann.

**Nicht öffentlich sichtbare Daten:**
- Vollständige Mitgliederlisten sind nur für Teammitglieder einsehbar
- Bewerbungen sind nur für Kapitäne und Ko-Kapitäne einsehbar
- E-Mail-Adressen sind grundsätzlich nicht öffentlich

### 8.3 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der öffentlichen Darstellung des Ligabetriebs zur Erfüllung des Vereinszwecks).

### 8.4 Hinweis zur Verantwortlichkeit

Die Faculties Football League e.V. ist Organisatorin des Ligabetriebs. Wir bringen Teams zusammen und stellen die technische Infrastruktur bereit. Für Vorgänge auf dem Spielfeld sowie für Handlungen der einzelnen Teams und Spieler/innen übernehmen wir keine Verantwortung.

---

## 9. App-Analyse und Nutzungsstatistiken (PostHog)

### 9.1 Beschreibung und Umfang der Datenverarbeitung

Wir setzen PostHog, einen Analysedienst, zur Verbesserung unserer App ein. PostHog ermöglicht uns zu verstehen, wie die App genutzt wird, um Fehler zu beheben, Funktionen zu verbessern und die Nutzungserfahrung zu optimieren.

Dabei können folgende Daten verarbeitet werden:

- Anonyme oder pseudonyme Nutzer-ID
- Aufgerufene Bildschirme und Funktionen (Events)
- Interaktionen mit App-Elementen
- Geräteinformationen (Gerättyp, Betriebssystem, Version)
- App-Version
- Zeitstempel der Aktionen
- Verbindungs- und Sitzungsinformationen

**Wir nutzen PostHog EU-Cloud** (eu.posthog.com). Alle Daten werden ausschließlich in der Europäischen Union gespeichert und verarbeitet (Rechenzentrum: Frankfurt, Deutschland, betrieben über Google Cloud Platform Europe).

IP-Adressen werden von PostHog vor der Speicherung anonymisiert. Wir konfigurieren PostHog so, dass keine eindeutig identifizierenden personenbezogenen Daten (wie Name oder E-Mail-Adresse) in Analyseereignissen enthalten sind.

### 9.2 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der Analyse und Verbesserung der App-Funktionalität sowie der Behebung technischer Fehler.

### 9.3 Auftragsverarbeiter und Drittlandtransfer

Anbieter: **PostHog, Inc.**, 965 Mission St, Suite 425, San Francisco, CA 94103, USA.

Da wir **PostHog EU-Cloud** nutzen, werden Ihre Daten in der EU gespeichert und verarbeitet. Eine Übermittlung in die USA findet nicht statt. Eine Auftragsverarbeitungsvereinbarung gemäß Art. 28 DSGVO besteht mit PostHog. Weitere Informationen: posthog.com/privacy

### 9.4 Widerspruchsmöglichkeit

Sie können der Nutzungsanalyse in den App-Einstellungen widersprechen. Bitte wenden Sie sich hierfür an uns unter levi.frim@facultiesfootballleague.de.

---

## 10. Authentifizierung über DFN-AAI

### 10.1 Beschreibung

Die Faculties Football League e.V. nutzt den DFN-AAI-Dienst des Vereins zur Förderung eines Deutschen Forschungsnetzes e.V. (DFN-Verein) als Proxy für die Authentifizierung. Der DFN-AAI-Dienst ermöglicht die Anbindung verschiedener Proxy-Instanzen (Bildungsproxy, edu-ID-Proxy, OIDC-Proxy, NFDI-Infrastrukturproxy).

### 10.2 Übermittelte Daten

Bei der Authentifizierung über DFN-AAI werden die folgenden Daten an unsere Systeme übertragen:

- Name
- E-Mail-Adresse
- Sonstige Identifikatoren der nutzenden Person
- Ggf. Gruppenzugehörigkeiten und Rollen innerhalb der Heimateinrichtung
- Ggf. Meldeadresse (bei edu-ID-Proxy)

### 10.3 Auftragsverarbeitungsvereinbarung

Zwischen der Faculties Football League e.V. (Auftraggeber/Verantwortlicher) und dem DFN-Verein (Auftragnehmer/Auftragsverarbeiter) besteht eine Auftragsverarbeitungsvereinbarung gemäß Art. 28 DSGVO. Unterauftragsverarbeiter des DFN-Vereins für diesen Dienst ist die **DFN-CERT Services GmbH**, Nagelsweg 41, D-20097 Hamburg.

Weitere Informationen zum DFN-Verein und seinen Datenschutzpraktiken sind unter dfn.de abrufbar.

### 10.4 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Erfüllung des Vertragsverhältnisses).

---

## 11. Hosting und Infrastruktur (Hetzner)

### 11.1 Beschreibung

Der Betrieb unserer App-Backend-Infrastruktur, der Datenbank und des Objektspeichers (für Profilbilder und Team-Logos) erfolgt auf Servern der **Hetzner Online GmbH**, Industriestr. 25, 91710 Gunzenhausen, Deutschland.

Hetzner betreibt Rechenzentren in Deutschland und Finnland. Unsere Infrastruktur wird in deutschen Rechenzentren betrieben.

### 11.2 Verarbeitete Daten

Alle durch die App verarbeiteten und gespeicherten personenbezogenen Daten (Profildaten, Teamdaten, Sitzungsdaten, hochgeladene Bilder) werden auf Hetzner-Servern gespeichert. Hetzner hat als Auftragsverarbeiter keinen Zugriff auf die Inhalte der Daten außer im Rahmen technischer Wartungs- und Supportleistungen.

### 11.3 Rechtsgrundlage und Auftragsverarbeitungsvereinbarung

Es besteht eine Auftragsverarbeitungsvereinbarung mit Hetzner Online GmbH gemäß Art. 28 DSGVO. Da Hetzner ein deutsches Unternehmen ist und die Daten in Deutschland gespeichert werden, findet keine Übermittlung in Drittländer außerhalb der EU/EEA statt. Weitere Informationen: hetzner.com/de/legal/privacy

---

## 12. Google OAuth (Authentifizierung)

### 12.1 Beschreibung

Für die Anmeldung in der App nutzen wir Google OAuth, einen Authentifizierungsdienst von Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.

Bei der Anmeldung über Google werden folgende Daten von Google an uns übermittelt:

- Name
- E-Mail-Adresse
- Google-Konto-ID

Wir erhalten keinen dauerhaften Zugriff auf Ihr Google-Konto. Der OAuth-Prozess dient ausschließlich der Identifikation und Authentifizierung.

### 12.2 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO sowie Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO, die Sie durch die Nutzung des Google-Anmeldebuttons erteilen.

### 12.3 Datenschutzerklärung von Google

Informationen zu den Datenschutzpraktiken von Google finden Sie unter policies.google.com/privacy.

---

## 13. Lokale Datenspeicherung auf dem Gerät

### 13.1 Sicherer Schlüsselspeicher (Secure Store)

Zur Speicherung Ihres Authentifizierungs-Tokens nutzt die App den verschlüsselten Schlüsselspeicher Ihres Geräts (auf iOS: Keychain, auf Android: Encrypted SharedPreferences via Expo SecureStore). Hierbei werden folgende Daten lokal gespeichert:

- Sitzungstoken (verschlüsselt)

Dieser Token wird beim Abmelden oder bei der Account-Löschung automatisch vom Gerät entfernt.

### 13.2 In-Memory-Cache

Die App nutzt React Query zur In-Memory-Zwischenspeicherung von API-Antworten während einer aktiven App-Sitzung. Diese Daten werden nicht persistent gespeichert und nach Beendigung der App automatisch gelöscht.

---

## 14. Berechtigungen der App

Die App fordert folgende Gerätezugriffe an:

| Berechtigung | Zweck | Erforderlichkeit |
|---|---|---|
| Zugriff auf Fotomediathek (Lesen) | Hochladen von Profilbild und Team-Logo | Freiwillig – ohne Bild kann kein Profilbild gesetzt werden |
| Internetzugang | Verbindung zum Backend-Server | Technisch notwendig |

**Nicht angeforderte Berechtigungen:** Standort, Kamera, Mikrofon, Kontakte, Kalender, Bluetooth, biometrische Daten, Push-Benachrichtigungen.

---

## 15. Datenübermittlung in Drittländer

Grundsätzlich werden Ihre Daten innerhalb der Europäischen Union (EU) bzw. des Europäischen Wirtschaftsraums (EWR) verarbeitet und gespeichert:

| Dienst | Land | Rechtsgrundlage |
|---|---|---|
| Hetzner Online GmbH | Deutschland (EU) | Auftragsverarbeitungsvertrag, kein Drittlandtransfer |
| DFN-Verein | Deutschland (EU) | Auftragsverarbeitungsvertrag, kein Drittlandtransfer |
| Stripe Payments Europe | Irland (EU) | Auftragsverarbeitungsvertrag, kein Drittlandtransfer |
| Google Ireland Ltd. | Irland (EU) | DPA, ggf. Übermittlung in USA gemäß Art. 46 DSGVO (SCCs) |
| PostHog EU-Cloud | EU (Frankfurt/Deutschland) | Auftragsverarbeitungsvertrag, kein Drittlandtransfer |

Bei Google Ireland Ltd. können Daten im Rahmen der Infrastruktur von Google LLC (USA) verarbeitet werden. Google stützt solche Übermittlungen auf die Standardvertragsklauseln der EU-Kommission gemäß Art. 46 Abs. 2 lit. c DSGVO.

---

## 16. Rechte der betroffenen Personen

Als von der Datenverarbeitung betroffene Person stehen Ihnen folgende Rechte zu:

### 16.1 Auskunftsrecht (Art. 15 DSGVO)

Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob Sie betreffende personenbezogene Daten verarbeitet werden, und ggf. Auskunft über diese personenbezogenen Daten sowie weitere damit verbundene Informationen (Verarbeitungszwecke, Empfänger, Speicherdauer etc.) zu erhalten.

### 16.2 Recht auf Berichtigung (Art. 16 DSGVO)

Sie haben das Recht, unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogener Daten zu verlangen. Unter Berücksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollständigung unvollständiger personenbezogener Daten zu verlangen.

### 16.3 Recht auf Löschung (Art. 17 DSGVO – „Recht auf Vergessenwerden")

Sie haben das Recht, zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht werden, sofern einer der in Art. 17 Abs. 1 DSGVO genannten Gründe zutrifft und die Verarbeitung nicht für einen der in Art. 17 Abs. 3 DSGVO genannten Zwecke erforderlich ist.

### 16.4 Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)

Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen, wenn eine der in Art. 18 Abs. 1 DSGVO genannten Voraussetzungen gegeben ist.

### 16.5 Recht auf Datenübertragbarkeit (Art. 20 DSGVO)

Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten, und Sie haben das Recht, diese Daten einem anderen Verantwortlichen zu übermitteln.

### 16.6 Widerspruchsrecht (Art. 21 DSGVO)

Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen) erfolgt, Widerspruch einzulegen. Im Falle des Widerspruchs verarbeiten wir die betreffenden personenbezogenen Daten nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.

### 16.7 Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO)

Soweit die Verarbeitung auf Ihrer Einwilligung beruht, haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.

### 16.8 Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)

Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs haben Sie das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt.

**Zuständige Aufsichtsbehörde für die Faculties Football League e.V. (Bayern):**

Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)  
Promenade 27  
91522 Ansbach  
Telefon: +49 981 180093-0  
E-Mail: poststelle@lda.bayern.de  
Website: lda.bayern.de

Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: levi.frim@facultiesfootballleague.de

---

## 17. Automatisierte Entscheidungsfindung und Profiling

Wir setzen keine automatisierte Entscheidungsfindung oder Profiling im Sinne von Art. 22 DSGVO ein. Alle Entscheidungen, die rechtliche Wirkungen für Sie entfalten oder Sie ähnlich erheblich beeinträchtigen, werden von Menschen getroffen.

---

## 18. Datensicherheit

Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.

Im Einzelnen setzen wir folgende Maßnahmen ein:

- **Verschlüsselung der Übertragung:** Alle Datenübertragungen zwischen App und Server erfolgen über HTTPS (TLS/SSL-Verschlüsselung).
- **Verschlüsselung der Speicherung:** Authentifizierungstoken auf dem Gerät werden in verschlüsseltem Speicher (iOS Keychain / Android Encrypted SharedPreferences) abgelegt.
- **Zugangskontrolle:** Zugriff auf Produktionsdaten ist auf autorisiertes Personal beschränkt. Datenbankzugänge sind durch starke Passwörter und ggf. SSH-Tunneling gesichert.
- **Minimale Datenspeicherung:** Kreditkartendaten werden nicht auf unseren Servern gespeichert; die Abwicklung erfolgt ausschließlich über den PCI-DSS-zertifizierten Dienst Stripe.
- **OAuth-Token-Sicherheit:** OAuth-Zugriffs- und Aktualisierungstoken werden verschlüsselt in der Datenbank gespeichert.
- **Zeitlich begrenzte Upload-URLs:** Signierte URLs für Datei-Uploads haben eine Gültigkeitsdauer von 5 Minuten.

---

## 19. Einbeziehung von Auftragsverarbeitern

Zur Erbringung unserer Dienste setzen wir folgende Auftragsverarbeiter ein, mit denen Auftragsverarbeitungsvereinbarungen gemäß Art. 28 DSGVO geschlossen wurden:

| Dienstleister | Sitz | Verarbeiteter Datensatz | Zweck |
|---|---|---|---|
| Hetzner Online GmbH | Gunzenhausen, Deutschland | Alle Backend-Daten, Bilder | Server-Hosting, Datenbankbetrieb, Objektspeicher |
| DFN-Verein (Verein zur Förderung eines Deutschen Forschungsnetzes e.V.) | Berlin, Deutschland | Name, E-Mail, Identifikatoren | OAuth-Proxy (DFN-AAI) |
| DFN-CERT Services GmbH (Unterauftragnehmer des DFN-Vereins) | Hamburg, Deutschland | Wie DFN-Verein | IT-Sicherheit, Incident Response |
| Stripe Payments Europe, Limited | Dublin, Irland | Zahlungsdaten | Zahlungsabwicklung |
| Google Ireland Limited | Dublin, Irland | Name, E-Mail, Google-ID | Authentifizierung (OAuth) |
| PostHog, Inc. (EU Cloud) | EU/Frankfurt, Deutschland | Pseudonyme Nutzungsdaten | App-Analyse |

---

## 20. Speicherdauerübersicht

| Datenkategorie | Speicherdauer |
|---|---|
| Account- und Profildaten | Bis zur Löschung des Accounts; danach unverzügliche Löschung |
| Session-/Protokolldaten (IP, User-Agent) | Max. 30 Tage nach Sitzungsende |
| OAuth-Token | Bis Ablauf oder Widerruf |
| Zahlungsdaten (Stripe-Kunden-ID) | Dauer des Vertragsverhältnisses + 10 Jahre (§ 147 AO, § 257 HGB) |
| Hochgeladene Bilder (Profilbild, Team-Logo) | Bis zur Löschung des Accounts/Teams |
| PostHog-Analysedaten | Max. 1 Jahr (anonymisiert/pseudonymisiert) |
| Team- und Mitgliedschaftsdaten | Bis zur Auflösung des Teams oder Austritt des Mitglieds |
| Liga- und Spielstatistiken | Dauerhaft (historische Ligadaten), jedoch ohne personenbezogenen Bezug soweit möglich |

---

## 21. Kinder und Jugendliche

Unsere App richtet sich nicht an Kinder unter 16 Jahren. Wir erheben wissentlich keine personenbezogenen Daten von Kindern unter 16 Jahren. Falls uns bekannt wird, dass wir Daten einer Person unter 16 Jahren ohne Einwilligung des Erziehungsberechtigten erhoben haben, werden diese Daten unverzüglich gelöscht.

---

## 22. Apple App Store und Google Play Store

### 22.1 App Store (Apple)

Der Download der App erfolgt über den Apple App Store. Dabei können Daten durch Apple Inc. (Cupertino, CA, USA) verarbeitet werden. Die Datenschutzerklärung von Apple ist unter apple.com/de/privacy abrufbar. Die Faculties Football League e.V. hat keinen Einfluss auf die Datenverarbeitung durch Apple im Rahmen des App-Store-Betriebs.

### 22.2 Google Play Store (Google)

Der Download der App für Android-Geräte erfolgt über den Google Play Store. Dabei können Daten durch Google LLC (USA) bzw. Google Ireland Limited verarbeitet werden. Die Datenschutzerklärung von Google ist unter policies.google.com/privacy abrufbar.

---

## 23. Änderungen dieser Datenschutzerklärung

Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z. B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung. Das Datum der letzten Änderung (Stand) ist oben auf dieser Seite angegeben. Wesentliche Änderungen werden Ihnen innerhalb der App mitgeteilt.

---

## 24. Kontakt und Ausübung Ihrer Rechte

Für Fragen zu dieser Datenschutzerklärung, zur Ausübung Ihrer Datenschutzrechte (Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch, Datenübertragbarkeit) oder bei sonstigen datenschutzrechtlichen Anliegen wenden Sie sich bitte an:

**Faculties Football League e.V.**  
z.H. Datenschutzbeauftragte/r  
Arcisstraße 17  
c/o Studentische Vertretung  
80333 München  
E-Mail: levi.frim@facultiesfootballleague.de

Wir werden Ihre Anfrage schnellstmöglich, in der Regel innerhalb von einem Monat, bearbeiten.

---

*Diese Datenschutzerklärung wurde unter Berücksichtigung der Datenschutz-Grundverordnung (DSGVO/EU 2016/679), des Bundesdatenschutzgesetzes (BDSG), des Bayerischen Datenschutzgesetzes (BayDSG) sowie der Anforderungen des Apple App Store und des Google Play Store erstellt.*

Die Session-Protokolldaten werden spätestens nach 30 Tagen gelöscht oder anonymisiert, sobald sie für die Zwecke, für die sie erhoben wurden, nicht mehr erforderlich sind.

---

## 5. Registrierung und Authentifizierung

### 5.1 Beschreibung und Umfang der Datenverarbeitung

Die Nutzung unserer App setzt eine Registrierung voraus. Die Authentifizierung erfolgt ausschließlich über Google OAuth, wobei die Weiterleitung der Anmeldedaten über den DFN-AAI-Proxy des Deutschen Forschungsnetzes (DFN-Verein) erfolgen kann. Dabei werden folgende personenbezogene Daten verarbeitet:

**Durch Google OAuth übermittelte Daten:**
- Vollständiger Name
- E-Mail-Adresse
- Google-Konto-Kennung (Account-ID)

**Durch DFN-AAI übermittelte Daten (bei Nutzung des Bildungsbereichs):**
- Name
- E-Mail-Adresse
- Sonstige Identifikatoren (z. B. universitäre Kennung)
- Ggf. Gruppenzugehörigkeiten und Rollen innerhalb der jeweiligen Heimateinrichtung
- Ggf. Meldeadresse

**In unserer Datenbank gespeicherte Daten:**
- Eindeutige Benutzer-ID (UUID)
- Vollständiger Name
- E-Mail-Adresse (verifiziert)
- Profilbild (URL zum Speicherort)
- Stripe-Kunden-ID (bei Zahlungen)
- Erstellungsdatum und Datum der letzten Aktualisierung
- OAuth-Provider-ID und -Typ
- OAuth-Zugriffs- und Aktualisierungstoken (verschlüsselt)

**Session-Daten:**
- Sitzungstoken
- IP-Adresse
- User-Agent (Geräteinformationen, Browser-/App-Version)
- Ablaufzeit der Sitzung

### 5.2 Rechtsgrundlage

Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO. Dient die Registrierung der Vorbereitung oder Erfüllung eines Vertrages, so ist Art. 6 Abs. 1 lit. b DSGVO zusätzliche Rechtsgrundlage. Die Speicherung von IP-Adresse und User-Agent im Rahmen der Sitzungsverwaltung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (Sicherheit und Missbrauchsprävention).

### 5.3 Dauer der Speicherung

Die Registrierungs- und Profildaten werden gespeichert, solange der Account besteht. Sitzungsdaten werden nach Ablauf der Sitzung oder nach dem Abmelden automatisch gelöscht. Sitzungstoken laufen nach einer definierten Inaktivitätsphase automatisch ab.

### 5.4 Widerspruchs- und Beseitigungsmöglichkeit

Als Nutzer/in haben Sie jederzeit die Möglichkeit, Ihre Registrierung aufzuheben. Die über Sie gespeicherten Daten können Sie jederzeit abändern lassen (Kontakt: levi.frim@facultiesfootballleague.de). Bei Löschung des Accounts werden alle personenbezogenen Daten einschließlich verknüpfter Team-Mitgliedschaften, Sitzungsdaten und OAuth-Verbindungen durch automatische Kaskadierung gelöscht.

---

## 6. Profilbild und Medien-Uploads

### 6.1 Beschreibung und Umfang der Datenverarbeitung

Die App ermöglicht das Hochladen eines Profilbilds (Nutzerfoto) sowie eines Team-Logos. Hierzu werden folgende Daten verarbeitet:

- Das von Ihnen ausgewählte Bild aus Ihrer Gerätegalerie
- Vorübergehende Speicherung im Gerätedateisystem während des Upload-Vorgangs
- Permanente Speicherung in unserem S3-kompatiblen Objektspeicher (Hetzner) unter einem eindeutigen Pfad (\`user-images/{BenutzerID}\` bzw. \`team-images/{TeamID}\`)
- Öffentlich zugängliche URL des hochgeladenen Bildes

Profilbilder sind für andere eingeloggte Nutzer/innen der App sichtbar. Team-Logos sind öffentlich auf der Website und in der App sichtbar.

Die App fordert für die Bildauswahl folgende Geräteberechtigung an:
- **Zugriff auf die Fotomediathek** (Lesen): Notwendig zur Auswahl eines Profilbilds oder Team-Logos

Hinweis: Die optionale Funktion zur Hintergrundentfernung bei Team-Logos wird vollständig lokal auf Ihrem Gerät verarbeitet. Dabei werden keine Bilddaten an externe Dienste übermittelt.

### 6.2 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Erfüllung des Vertragsverhältnisses für die Nutzung der App).

### 6.3 Dauer der Speicherung

Bilder werden im Objektspeicher gespeichert, solange der entsprechende Account oder das Team besteht. Nach Löschung des Accounts oder Teams werden die Bilder unverzüglich aus dem Objektspeicher entfernt.

---

## 7. Zahlungsabwicklung (Season Pass)

### 7.1 Beschreibung und Umfang der Datenverarbeitung

Zur Teilnahme an der Saison ist der Erwerb eines „Season Pass" erforderlich. Die Zahlungsabwicklung erfolgt über den Zahlungsdienstleister Stripe. Bei der Abwicklung von Zahlungen werden folgende Daten verarbeitet:

- Stripe-Kunden-ID (in unserer Datenbank gespeichert, verknüpft mit Ihrem Account)
- Zahlungsintent-Client-Secret (temporär für die Zahlung)
- Zahlungsbetrag und Währung (EUR)
- Zahlungsstatus und Zeitstempel

**Wichtig:** Kreditkartendaten und sonstige vollständige Zahlungsinformationen werden **nicht** auf unseren Servern gespeichert. Diese werden ausschließlich von Stripe verschlüsselt verarbeitet und gespeichert. Stripe ist als Zahlungsdienstleister nach PCI DSS zertifiziert.

Beim Anlegen Ihres Accounts wird automatisch ein Stripe-Kundenprofil erstellt, dem eine eindeutige Kunden-ID zugewiesen wird.

### 7.2 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. c DSGVO (Erfüllung steuerrechtlicher und handelsrechtlicher Aufzeichnungspflichten nach § 147 AO, § 257 HGB).

### 7.3 Auftragsverarbeiter

Zahlungsabwicklung: **Stripe Payments Europe, Limited**, 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, D02 H210, Irland. Eine Auftragsverarbeitungsvereinbarung gemäß Art. 28 DSGVO besteht mit Stripe. Die Datenschutzerklärung von Stripe ist unter stripe.com/de/privacy abrufbar.

### 7.4 Dauer der Speicherung

Zahlungsdaten (insbesondere die Stripe-Kunden-ID in unserem System) werden für die Dauer des Vertragsverhältnisses und anschließend für die gesetzlich vorgeschriebenen Aufbewahrungsfristen (mindestens 10 Jahre gemäß § 147 AO, § 257 HGB) gespeichert.

---

## 8. Team-Funktionen und Liga-Verwaltung

### 8.1 Beschreibung und Umfang der Datenverarbeitung

Die Kernfunktion unserer App ist die Verwaltung von Fußballteams und die Organisation von Ligaspielen. Hierzu verarbeiten wir folgende Daten:

**Team-Daten:**
- Teamname
- Team-Kürzel (3-Buchstaben-Kennung)
- Team-Logo
- Teamgründungsdatum
- Mitgliederrollen: Kapitän (CAPTAIN), Ko-Kapitän (CO_CAPTAIN), Mitglied (MEMBER), Bewerber/in (APPLICANT)

**Mitgliedschaftsdaten:**
- Zuordnung von Nutzer/innen zu Teams
- Rollen und Berechtigungen innerhalb des Teams
- Bewerbungsstatus

**Ligadaten:**
- Saison-Informationen
- Spielpaarungen (geplante Funktion)
- Statistiken: Siege, Niederlagen, Unentschieden, Rangliste (geplante Funktion)
- Ergebnisse

### 8.2 Öffentlich sichtbare Daten

Folgende Daten werden **öffentlich** auf unserer Website (facultiesfootballleague.de) und in der App angezeigt:

- Teamname
- Team-Kürzel
- Team-Logo
- Name des/der Teamkapitän/s
- Anzahl der Teammitglieder
- Ligatabelle und Statistiken (Siege, Niederlagen, Unentschieden, Punkte)
- Spielergebnisse

Mit der Annahme der Nutzungsbedingungen und der Registrierung in der App stimmen Sie zu, dass Ihr Name als Kapitän/Ko-Kapitän öffentlich sichtbar sein kann.

**Nicht öffentlich sichtbare Daten:**
- Vollständige Mitgliederlisten sind nur für Teammitglieder einsehbar
- Bewerbungen sind nur für Kapitäne und Ko-Kapitäne einsehbar
- E-Mail-Adressen sind grundsätzlich nicht öffentlich

### 8.3 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der öffentlichen Darstellung des Ligabetriebs zur Erfüllung des Vereinszwecks).

### 8.4 Hinweis zur Verantwortlichkeit

Die Faculties Football League e.V. ist Organisatorin des Ligabetriebs. Wir bringen Teams zusammen und stellen die technische Infrastruktur bereit. Für Vorgänge auf dem Spielfeld sowie für Handlungen der einzelnen Teams und Spieler/innen übernehmen wir keine Verantwortung.

---

## 9. App-Analyse und Nutzungsstatistiken (PostHog)

### 9.1 Beschreibung und Umfang der Datenverarbeitung

Wir setzen PostHog, einen Analysedienst, zur Verbesserung unserer App ein. PostHog ermöglicht uns zu verstehen, wie die App genutzt wird, um Fehler zu beheben, Funktionen zu verbessern und die Nutzungserfahrung zu optimieren.

Dabei können folgende Daten verarbeitet werden:

- Anonyme oder pseudonyme Nutzer-ID
- Aufgerufene Bildschirme und Funktionen (Events)
- Interaktionen mit App-Elementen
- Geräteinformationen (Gerättyp, Betriebssystem, Version)
- App-Version
- Zeitstempel der Aktionen
- Verbindungs- und Sitzungsinformationen

**Wir nutzen PostHog EU-Cloud** (eu.posthog.com). Alle Daten werden ausschließlich in der Europäischen Union gespeichert und verarbeitet (Rechenzentrum: Frankfurt, Deutschland, betrieben über Google Cloud Platform Europe).

IP-Adressen werden von PostHog vor der Speicherung anonymisiert. Wir konfigurieren PostHog so, dass keine eindeutig identifizierenden personenbezogenen Daten (wie Name oder E-Mail-Adresse) in Analyseereignissen enthalten sind.

### 9.2 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der Analyse und Verbesserung der App-Funktionalität sowie der Behebung technischer Fehler.

### 9.3 Auftragsverarbeiter und Drittlandtransfer

Anbieter: **PostHog, Inc.**, 965 Mission St, Suite 425, San Francisco, CA 94103, USA.

Da wir **PostHog EU-Cloud** nutzen, werden Ihre Daten in der EU gespeichert und verarbeitet. Eine Übermittlung in die USA findet nicht statt. Eine Auftragsverarbeitungsvereinbarung gemäß Art. 28 DSGVO besteht mit PostHog. Weitere Informationen: posthog.com/privacy

### 9.4 Widerspruchsmöglichkeit

Sie können der Nutzungsanalyse in den App-Einstellungen widersprechen. Bitte wenden Sie sich hierfür an uns unter levi.frim@facultiesfootballleague.de.

---

## 10. Authentifizierung über DFN-AAI

### 10.1 Beschreibung

Die Faculties Football League e.V. nutzt den DFN-AAI-Dienst des Vereins zur Förderung eines Deutschen Forschungsnetzes e.V. (DFN-Verein) als Proxy für die Authentifizierung. Der DFN-AAI-Dienst ermöglicht die Anbindung verschiedener Proxy-Instanzen (Bildungsproxy, edu-ID-Proxy, OIDC-Proxy, NFDI-Infrastrukturproxy).

### 10.2 Übermittelte Daten

Bei der Authentifizierung über DFN-AAI werden die folgenden Daten an unsere Systeme übertragen:

- Name
- E-Mail-Adresse
- Sonstige Identifikatoren der nutzenden Person
- Ggf. Gruppenzugehörigkeiten und Rollen innerhalb der Heimateinrichtung
- Ggf. Meldeadresse (bei edu-ID-Proxy)

### 10.3 Auftragsverarbeitungsvereinbarung

Zwischen der Faculties Football League e.V. (Auftraggeber/Verantwortlicher) und dem DFN-Verein (Auftragnehmer/Auftragsverarbeiter) besteht eine Auftragsverarbeitungsvereinbarung gemäß Art. 28 DSGVO. Unterauftragsverarbeiter des DFN-Vereins für diesen Dienst ist die **DFN-CERT Services GmbH**, Nagelsweg 41, D-20097 Hamburg.

Weitere Informationen zum DFN-Verein und seinen Datenschutzpraktiken sind unter dfn.de abrufbar.

### 10.4 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Erfüllung des Vertragsverhältnisses).

---

## 11. Hosting und Infrastruktur (Hetzner)

### 11.1 Beschreibung

Der Betrieb unserer App-Backend-Infrastruktur, der Datenbank und des Objektspeichers (für Profilbilder und Team-Logos) erfolgt auf Servern der **Hetzner Online GmbH**, Industriestr. 25, 91710 Gunzenhausen, Deutschland.

Hetzner betreibt Rechenzentren in Deutschland und Finnland. Unsere Infrastruktur wird in deutschen Rechenzentren betrieben.

### 11.2 Verarbeitete Daten

Alle durch die App verarbeiteten und gespeicherten personenbezogenen Daten (Profildaten, Teamdaten, Sitzungsdaten, hochgeladene Bilder) werden auf Hetzner-Servern gespeichert. Hetzner hat als Auftragsverarbeiter keinen Zugriff auf die Inhalte der Daten außer im Rahmen technischer Wartungs- und Supportleistungen.

### 11.3 Rechtsgrundlage und Auftragsverarbeitungsvereinbarung

Es besteht eine Auftragsverarbeitungsvereinbarung mit Hetzner Online GmbH gemäß Art. 28 DSGVO. Da Hetzner ein deutsches Unternehmen ist und die Daten in Deutschland gespeichert werden, findet keine Übermittlung in Drittländer außerhalb der EU/EEA statt. Weitere Informationen: hetzner.com/de/legal/privacy

---

## 12. Google OAuth (Authentifizierung)

### 12.1 Beschreibung

Für die Anmeldung in der App nutzen wir Google OAuth, einen Authentifizierungsdienst von Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.

Bei der Anmeldung über Google werden folgende Daten von Google an uns übermittelt:

- Name
- E-Mail-Adresse
- Google-Konto-ID

Wir erhalten keinen dauerhaften Zugriff auf Ihr Google-Konto. Der OAuth-Prozess dient ausschließlich der Identifikation und Authentifizierung.

### 12.2 Rechtsgrundlage

Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO sowie Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO, die Sie durch die Nutzung des Google-Anmeldebuttons erteilen.

### 12.3 Datenschutzerklärung von Google

Informationen zu den Datenschutzpraktiken von Google finden Sie unter policies.google.com/privacy.

---

## 13. Lokale Datenspeicherung auf dem Gerät

### 13.1 Sicherer Schlüsselspeicher (Secure Store)

Zur Speicherung Ihres Authentifizierungs-Tokens nutzt die App den verschlüsselten Schlüsselspeicher Ihres Geräts (auf iOS: Keychain, auf Android: Encrypted SharedPreferences via Expo SecureStore). Hierbei werden folgende Daten lokal gespeichert:

- Sitzungstoken (verschlüsselt)

Dieser Token wird beim Abmelden oder bei der Account-Löschung automatisch vom Gerät entfernt.

### 13.2 In-Memory-Cache

Die App nutzt React Query zur In-Memory-Zwischenspeicherung von API-Antworten während einer aktiven App-Sitzung. Diese Daten werden nicht persistent gespeichert und nach Beendigung der App automatisch gelöscht.

---

## 14. Berechtigungen der App

Die App fordert folgende Gerätezugriffe an:

| Berechtigung | Zweck | Erforderlichkeit |
|---|---|---|
| Zugriff auf Fotomediathek (Lesen) | Hochladen von Profilbild und Team-Logo | Freiwillig – ohne Bild kann kein Profilbild gesetzt werden |
| Internetzugang | Verbindung zum Backend-Server | Technisch notwendig |

**Nicht angeforderte Berechtigungen:** Standort, Kamera, Mikrofon, Kontakte, Kalender, Bluetooth, biometrische Daten, Push-Benachrichtigungen.

---

## 15. Datenübermittlung in Drittländer

Grundsätzlich werden Ihre Daten innerhalb der Europäischen Union (EU) bzw. des Europäischen Wirtschaftsraums (EWR) verarbeitet und gespeichert:

| Dienst | Land | Rechtsgrundlage |
|---|---|---|
| Hetzner Online GmbH | Deutschland (EU) | Auftragsverarbeitungsvertrag, kein Drittlandtransfer |
| DFN-Verein | Deutschland (EU) | Auftragsverarbeitungsvertrag, kein Drittlandtransfer |
| Stripe Payments Europe | Irland (EU) | Auftragsverarbeitungsvertrag, kein Drittlandtransfer |
| Google Ireland Ltd. | Irland (EU) | DPA, ggf. Übermittlung in USA gemäß Art. 46 DSGVO (SCCs) |
| PostHog EU-Cloud | EU (Frankfurt/Deutschland) | Auftragsverarbeitungsvertrag, kein Drittlandtransfer |

Bei Google Ireland Ltd. können Daten im Rahmen der Infrastruktur von Google LLC (USA) verarbeitet werden. Google stützt solche Übermittlungen auf die Standardvertragsklauseln der EU-Kommission gemäß Art. 46 Abs. 2 lit. c DSGVO.

---

## 16. Rechte der betroffenen Personen

Als von der Datenverarbeitung betroffene Person stehen Ihnen folgende Rechte zu:

### 16.1 Auskunftsrecht (Art. 15 DSGVO)

Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob Sie betreffende personenbezogene Daten verarbeitet werden, und ggf. Auskunft über diese personenbezogenen Daten sowie weitere damit verbundene Informationen (Verarbeitungszwecke, Empfänger, Speicherdauer etc.) zu erhalten.

### 16.2 Recht auf Berichtigung (Art. 16 DSGVO)

Sie haben das Recht, unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogener Daten zu verlangen. Unter Berücksichtigung der Zwecke der Verarbeitung haben Sie das Recht, die Vervollständigung unvollständiger personenbezogener Daten zu verlangen.

### 16.3 Recht auf Löschung (Art. 17 DSGVO – „Recht auf Vergessenwerden")

Sie haben das Recht, zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht werden, sofern einer der in Art. 17 Abs. 1 DSGVO genannten Gründe zutrifft und die Verarbeitung nicht für einen der in Art. 17 Abs. 3 DSGVO genannten Zwecke erforderlich ist.

### 16.4 Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)

Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen, wenn eine der in Art. 18 Abs. 1 DSGVO genannten Voraussetzungen gegeben ist.

### 16.5 Recht auf Datenübertragbarkeit (Art. 20 DSGVO)

Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten, und Sie haben das Recht, diese Daten einem anderen Verantwortlichen zu übermitteln.

### 16.6 Widerspruchsrecht (Art. 21 DSGVO)

Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen) erfolgt, Widerspruch einzulegen. Im Falle des Widerspruchs verarbeiten wir die betreffenden personenbezogenen Daten nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.

### 16.7 Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO)

Soweit die Verarbeitung auf Ihrer Einwilligung beruht, haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.

### 16.8 Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)

Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs haben Sie das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt.

**Zuständige Aufsichtsbehörde für die Faculties Football League e.V. (Bayern):**

Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)  
Promenade 27  
91522 Ansbach  
Telefon: +49 981 180093-0  
E-Mail: poststelle@lda.bayern.de  
Website: lda.bayern.de

Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: levi.frim@facultiesfootballleague.de

---

## 17. Automatisierte Entscheidungsfindung und Profiling

Wir setzen keine automatisierte Entscheidungsfindung oder Profiling im Sinne von Art. 22 DSGVO ein. Alle Entscheidungen, die rechtliche Wirkungen für Sie entfalten oder Sie ähnlich erheblich beeinträchtigen, werden von Menschen getroffen.

---

## 18. Datensicherheit

Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.

Im Einzelnen setzen wir folgende Maßnahmen ein:

- **Verschlüsselung der Übertragung:** Alle Datenübertragungen zwischen App und Server erfolgen über HTTPS (TLS/SSL-Verschlüsselung).
- **Verschlüsselung der Speicherung:** Authentifizierungstoken auf dem Gerät werden in verschlüsseltem Speicher (iOS Keychain / Android Encrypted SharedPreferences) abgelegt.
- **Zugangskontrolle:** Zugriff auf Produktionsdaten ist auf autorisiertes Personal beschränkt. Datenbankzugänge sind durch starke Passwörter und ggf. SSH-Tunneling gesichert.
- **Minimale Datenspeicherung:** Kreditkartendaten werden nicht auf unseren Servern gespeichert; die Abwicklung erfolgt ausschließlich über den PCI-DSS-zertifizierten Dienst Stripe.
- **OAuth-Token-Sicherheit:** OAuth-Zugriffs- und Aktualisierungstoken werden verschlüsselt in der Datenbank gespeichert.
- **Zeitlich begrenzte Upload-URLs:** Signierte URLs für Datei-Uploads haben eine Gültigkeitsdauer von 5 Minuten.

---

## 19. Einbeziehung von Auftragsverarbeitern

Zur Erbringung unserer Dienste setzen wir folgende Auftragsverarbeiter ein, mit denen Auftragsverarbeitungsvereinbarungen gemäß Art. 28 DSGVO geschlossen wurden:

| Dienstleister | Sitz | Verarbeiteter Datensatz | Zweck |
|---|---|---|---|
| Hetzner Online GmbH | Gunzenhausen, Deutschland | Alle Backend-Daten, Bilder | Server-Hosting, Datenbankbetrieb, Objektspeicher |
| DFN-Verein (Verein zur Förderung eines Deutschen Forschungsnetzes e.V.) | Berlin, Deutschland | Name, E-Mail, Identifikatoren | OAuth-Proxy (DFN-AAI) |
| DFN-CERT Services GmbH (Unterauftragnehmer des DFN-Vereins) | Hamburg, Deutschland | Wie DFN-Verein | IT-Sicherheit, Incident Response |
| Stripe Payments Europe, Limited | Dublin, Irland | Zahlungsdaten | Zahlungsabwicklung |
| Google Ireland Limited | Dublin, Irland | Name, E-Mail, Google-ID | Authentifizierung (OAuth) |
| PostHog, Inc. (EU Cloud) | EU/Frankfurt, Deutschland | Pseudonyme Nutzungsdaten | App-Analyse |

---

## 20. Speicherdauerübersicht

| Datenkategorie | Speicherdauer |
|---|---|
| Account- und Profildaten | Bis zur Löschung des Accounts; danach unverzügliche Löschung |
| Session-/Protokolldaten (IP, User-Agent) | Max. 30 Tage nach Sitzungsende |
| OAuth-Token | Bis Ablauf oder Widerruf |
| Zahlungsdaten (Stripe-Kunden-ID) | Dauer des Vertragsverhältnisses + 10 Jahre (§ 147 AO, § 257 HGB) |
| Hochgeladene Bilder (Profilbild, Team-Logo) | Bis zur Löschung des Accounts/Teams |
| PostHog-Analysedaten | Max. 1 Jahr (anonymisiert/pseudonymisiert) |
| Team- und Mitgliedschaftsdaten | Bis zur Auflösung des Teams oder Austritt des Mitglieds |
| Liga- und Spielstatistiken | Dauerhaft (historische Ligadaten), jedoch ohne personenbezogenen Bezug soweit möglich |

---

## 21. Kinder und Jugendliche

Unsere App richtet sich nicht an Kinder unter 16 Jahren. Wir erheben wissentlich keine personenbezogenen Daten von Kindern unter 16 Jahren. Falls uns bekannt wird, dass wir Daten einer Person unter 16 Jahren ohne Einwilligung des Erziehungsberechtigten erhoben haben, werden diese Daten unverzüglich gelöscht.

---

## 22. Apple App Store und Google Play Store

### 22.1 App Store (Apple)

Der Download der App erfolgt über den Apple App Store. Dabei können Daten durch Apple Inc. (Cupertino, CA, USA) verarbeitet werden. Die Datenschutzerklärung von Apple ist unter apple.com/de/privacy abrufbar. Die Faculties Football League e.V. hat keinen Einfluss auf die Datenverarbeitung durch Apple im Rahmen des App-Store-Betriebs.

### 22.2 Google Play Store (Google)

Der Download der App für Android-Geräte erfolgt über den Google Play Store. Dabei können Daten durch Google LLC (USA) bzw. Google Ireland Limited verarbeitet werden. Die Datenschutzerklärung von Google ist unter policies.google.com/privacy abrufbar.

---

## 23. Änderungen dieser Datenschutzerklärung

Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z. B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung. Das Datum der letzten Änderung (Stand) ist oben auf dieser Seite angegeben. Wesentliche Änderungen werden Ihnen innerhalb der App mitgeteilt.

---

## 24. Kontakt und Ausübung Ihrer Rechte

Für Fragen zu dieser Datenschutzerklärung, zur Ausübung Ihrer Datenschutzrechte (Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch, Datenübertragbarkeit) oder bei sonstigen datenschutzrechtlichen Anliegen wenden Sie sich bitte an:

**Faculties Football League e.V.**  
z.H. Datenschutzbeauftragte/r  
Arcisstraße 17  
c/o Studentische Vertretung  
80333 München  
E-Mail: levi.frim@facultiesfootballleague.de

Wir werden Ihre Anfrage schnellstmöglich, in der Regel innerhalb von einem Monat, bearbeiten.

---

*Diese Datenschutzerklärung wurde unter Berücksichtigung der Datenschutz-Grundverordnung (DSGVO/EU 2016/679), des Bundesdatenschutzgesetzes (BDSG), des Bayerischen Datenschutzgesetzes (BayDSG) sowie der Anforderungen des Apple App Store und des Google Play Store erstellt.*;
`;
const DataPrivacy: React.FC = () => {
  return (
    <div className="flex flex-col w-screen items-center justify-center">
      <h1 className="text-3xl font-bold text-white mt-10">
        Datenschutzerklärung
      </h1>

      <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-lg p-6 m-6 max-w-3xl text-white shadow-lg border border-white/20">
        <div className="prose prose-invert max-w-none">
          <ReactMarkdown>{privacyMarkdown}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default DataPrivacy;
